import { showBtn } from '@eastmoney/mku';
import { DB_FXAN_BTN } from '@/libs/constant';
import { track } from '@/libs/tool';
import { ShareFlag } from '@/libs/enum';
import BrowserShare from './w-share';
import browser from './browser';

function setAppShareInfo(params) {
    const { title, desc, url, img } = params;
    window.shareSuccessCallback = () => {
        track(DB_FXAN_BTN);
    };
    const json = {
        type: 'weixin,pengyouquan',
        title,
        img,
        url,
        desc,
        callbackname: 'shareSuccessCallback'
    };
    if (browser.isIOS()) {
        return () => {
            window.location = `onwebshareclicked:${JSON.stringify(json)}`;
        };
    }
    return () => {
        if (window.__EM != 'undefined' && window.__EM.prompt != 'undefined') {
            window.__EM.prompt('onShareClicked', JSON.stringify(json));
        } else {
            prompt('onShareClicked', JSON.stringify(json));
        }
    };
}

export function initShare(params, shareFlag) {
    const { title, desc, url, img } = params;
    if (browser.isApp()) {
        const initShareInApp = () => {
            // app内分享
            if (shareFlag === ShareFlag.yes || shareFlag === undefined) {
                window.emH5ShareInfo = setAppShareInfo(params);
                const btnJson = {
                    type: 'share',
                    enable: 1,
                    callbackname: 'emH5ShareInfo'
                };
                if (browser.isIOS()) {
                    window.location = `emsettitlerightbtn:${JSON.stringify(btnJson)}`;
                } else if (window.__EM != 'undefined' && window.__EM.prompt != 'undefined') {
                    window.__EM.prompt('emSetTitleRightBtn', JSON.stringify(btnJson));
                } else {
                    prompt('emSetTitleRightBtn', JSON.stringify(btnJson));
                }
            } else {
                console.log('---- initShare in app: ', shareFlag);
                showBtn({
                    type: 'share',
                    enable: 0,
                    btntext: '',
                    cb() {}
                });
                window.onload = () => {
                    console.log(' --- window on load');
                    setTimeout(() => {
                        showBtn({
                            type: 'share',
                            enable: 0,
                            btntext: '',
                            cb() {}
                        });
                    }, 500);
                };
            }
        };
        // 此处使用异步去初始化分享
        // 是在当用cover页面生成二维码时候，但是配置上是不显示cover页面，就会导致无法显示分享
        // 使用异步后则可以正常显示
        let timer = setTimeout(() => {
            initShareInApp();
            clearTimeout(timer);
            timer = null;
        }, 300);
    } else {
        // 浏览器分享
        const config = {
            link: url,
            imgUrl: img,
            from: '东方财富移动版',
            title,
            desc
        };
        const share = new BrowserShare({
            shareData: config
        });
        share.initQQ({
            title: config.title, // 分享标题
            summary: config.desc || '  ', // 分享内容
            pic: config.imgUrl, // 分享图片
            url: config.link // 分享链接
        });
        return share;
    }
}
